/* global define, sessionStorage, JSON, console */

/* Refactor needed
   Single Responsibility Principle (there is a lot of mixed stuff in this file)
   - fetching templates and game data
   - fetching currency
   - formatting currency in game data (format data on output; alt: format data on server)
   - creating html output for games

   Other
   Using both store and emitter for games updated event is redundant
 */

import { emitter } from './../utils/custom-events.js';
import { open } from './../libs/tabs.js';
import { store } from './store.js';
import Handlebars from 'handlebars';
import { fetchJson } from './../core/ajax-json.js';
import currencyFormatter from './../libs/currency-formatter.js';
import { getLocale } from './../libs/locale.js';
import { gamesSelector } from './selectors.js';
import search from './search.js';

function gameList() {
	const d = new Date();
	const hourlyCacheBuster = `${d.getYear()}-${d.getMonth()}-${d.getDay()}-${d.getHours()}`;
	return fetchJson(`/rest/casino/game/list?t=${hourlyCacheBuster}`);
}


function getAllGames() {
	let allGames;

	try {
		allGames = store.get().gameResource.gameData.all;
		if (allGames.length > 0) {
			return;
		}
	} catch (e) {
		console.error('Failed retrieving allGames from store. Fetching from server');
	}

	return Promise.all([gameList(), fetchJson('/player/currency')])
		.then(([gameResource, currency]) => {
			/* Refactor
				 Skip the call to .map() entirely. The only thing it does is format currency,
				 which should be done when either
				 	- producing output (best bet)
				 	- when producing the game data array on the server (would need one cached version per combination of currency and language)
			 */
			gameResource.result.rootContext.gameData.all = gameResource.result.rootContext.gameData.all
				.map((game) => {
					if (game.jackpot) {
						game.jackpot = currencyFormatter.format(parseInt(game.jackpot, 10), currency.result, getLocale());
					}
					return game;
				});

			const tpls = gameResource.result.templates;

			Handlebars.registerPartial('game-tags', tpls['game-tags']);
			Handlebars.registerPartial('game-ref', tpls['games-ref']);
			Handlebars.registerPartial('explore-game-small', tpls['explore-game-small']);

			store.get().templates.set({
				games: Handlebars.compile(tpls.games)
			});

			const gameStore = {
				gameResource: gameResource.result.rootContext
			};

			store.get().set(gameStore);
			emitter.emit('allGamesFetchedAndStored');
		}).catch();
}

function getGamebyId($gameId) {
	return store.get().gameResource.gamedata.all.find(game => game.gameId === $gameId);
}

/* Refactor needed:
	Generic naming
	- ”render”. Specify what is being rendered: renderGames or renderGameList

	Code duplication (providergames.js)
	- The same logic is used to render things regardless of the data subset
	- The same logic is used to add things to the dom regardless of the target element
	- The same logic is used to decide if things should be rendered regardless of the target element
	Instead use
	- one function to render stuff, parameters: gamesData
	- one function to enter things into the dom, parameters: html, target element
	- one function deciding if need for render, parameters: target element
	 	this one should be called from the callback to ”store.on('update', callback => { call-from-here(targetEl) }
 */
function render() {
	const ariaHidden = (document.getElementById('section2') && document.getElementById('section2').getAttribute('aria-hidden'));
	const wrapElm = document.getElementById('all-games-wrapper');
	if (!ariaHidden && wrapElm) {
		const storage = store.get();
		const games = gamesSelector(storage);
		const templateContext = {
			...store.get().gameResource,
			...{
				gameData: {
					all: games,
				}
			}
		};

		wrapElm.innerHTML = store.get().templates.games(templateContext);
		search.setup();
		window.lazySizes.loader.checkElems();
	}
}

store.on('update', (currentState, prevState) => {
	if (currentState !== prevState) {
		render();
	}
});

function init() {
	search.init({
		input: '.search .search__input',
		content: '#section2 .game-grid'
	});
	open('section2');
}

export {
	init,
	getGamebyId,
	getAllGames
};



// WEBPACK FOOTER //
// ./mobile-core/src/casino/allgames.js